import { Calendar, CalendarDate } from 'calendar-base';

import { add, getYear, getMonth, isBefore, isSameDay } from 'date-fns';

const calendar = new Calendar({
  weekNumbers: true,
});

const getDaysArray = (
  initialDate: Date,
  numberMonths: number,
): CalendarDate[] => {
  const days: CalendarDate[] = [];

  for (let i = 0; i < numberMonths; i += 1) {
    (
      calendar
        .getCalendar(
          getYear(add(initialDate, { months: i })),
          getMonth(add(initialDate, { months: i })),
        )
        .filter(item => item !== false) as CalendarDate[]
    ).forEach(item => {
      if (
        !isBefore(new Date(item.year, item.month, item.day), initialDate) ||
        isSameDay(new Date(item.year, item.month, item.day), initialDate)
      ) {
        days.push(item as CalendarDate);
      }
    });
  }

  return days;
};

export { getDaysArray };
